import * as types from '../actions/action-types';

export const initialState = {
  isPudoAvailable: false,
  deliveryType: '',
  isValid: false,
};

export default function deliverySectionReducer(state = initialState, action) {
  switch (action.type) {
    case types.UPDATE_PUDO_STATUS:
      return {...state, isPudoAvailable: action.status};

    case types.UPDATE_DELIVERY_TYPE:
      return {...state, deliveryType: action.deliveryType};

    case types.UPDATE_VALID_STATUS:
      return {...state, isValid: action.isValid};

    case types.INIT_PUDO_GOOGLE_MAPS_SUCCESS:
      return {...state, isGoogleMapsAvailable: action.status};
  
    case types.SET_GOOGLE_MAPS_LOADING:
      return {...state, isGoogleMapsLoading: action.isLoading};

    default:
      return state;
  }
}
